import React from 'react';
import PropTypes from 'prop-types';
import { useChannelImageUri } from '../../../slice';
import { ProfileImage } from '../index';
import { ImageCreateChannel } from '../../rootAccess';

function ChannelProfileImage({ channelId, className, imgSrc, defaultImg = ImageCreateChannel, alt }) {
    const imageUri = useChannelImageUri(channelId);
    const finalImageUri = imgSrc !== undefined ? imgSrc : imageUri;

    return (
        <ProfileImage
            className={className}
            defaultImg={defaultImg}
            imageUri={finalImageUri}
            userId={channelId}
            alt={alt}
            key={channelId}
        />
    );
}

const Memoized = React.memo(ChannelProfileImage);
export { Memoized as ChannelProfileImage };

ChannelProfileImage.propTypes = {
    channelId: PropTypes.string.isRequired,
    className: PropTypes.string,
    defaultImg: PropTypes.string,
    alt: PropTypes.string,
    imgSrc: PropTypes.string,
};
